import { Component, Prop, Element } from '@stencil/core';
import { MultiColumnTeaserAppearance } from './multi-column-teaser.interface';

@Component({
	tag: 'ds-multi-column-teaser',
})
export class MultiColumnTeaser {
	@Element() el: HTMLDsMultiColumnTeaserElement;

	@Prop() contentType: 'icon' | 'freeText';
	@Prop() colsPerRowInDesktop = 4;
	@Prop() appearance?: MultiColumnTeaserAppearance = 'standard';

	componentDidLoad() {
		const topics = Array.from(this.el.querySelectorAll('.ds-topic'));
		const topicsLength = topics.length;
		const finalDesktopRowStartIndex =
			Math.floor((topicsLength - 1) / this.colsPerRowInDesktop) *
			this.colsPerRowInDesktop;
		const isEvenNumberOfTopics = !(topicsLength % 2);

		if (isEvenNumberOfTopics) {
			this.el.classList.add('ds-even-number-topics');
		}

		topics.forEach((topic, i) => {
			if (this.appearance === 'hero') {
				topic.classList.add('ds-topic-hero');
			}

			if (i >= finalDesktopRowStartIndex) {
				topic.classList.add('ds-final-desktop-row');
			}
		});

		const freetextItems = Array.from(
			this.el.querySelectorAll('.ds-topic-free-text')
		);
		let longestLength = 0;

		// How long is the longest?
		freetextItems.forEach((item) => {
			const itemContent = item.textContent.trim();
			longestLength =
				itemContent.length > longestLength ? itemContent.length : longestLength;
		});

		if (longestLength <= 4) {
			this.el.classList.add('ds-4-or-less-chars');
		} else if (longestLength <= 6) {
			this.el.classList.add('ds-5-or-6-chars');
		} else {
			this.el.classList.add('ds-7-or-more-chars');
		}
	}
}
